import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useSessionAsync } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

import { useMembershipModalState } from '../../../../modalContext';

type Result = {
	headline: string;
	description: string;
	isSunriseEnabled: boolean;
};

export function useHeader(): Result {
	const [{ isSunriseEnabled }] = useMembershipModalState();
	const { translate } = useI18n();
	const session = useSessionAsync();

	const { headlineSuffix, name } = useMemo(() => {
		if (!isLoaded(session)) {
			return { headlineSuffix: '', name: '' };
		}

		const isGuest = session.value.loginState === 'GUEST';
		const shortDisplayName = session.value.user?.shortDisplayName ?? '';

		return {
			headlineSuffix: isGuest ? '_guest' : '',
			name: shortDisplayName,
		};
	}, [session]);

	return {
		headline: translate(`corgi.co.ppmu.modal.heading${headlineSuffix}`, { name }),
		description: translate('corgi.co.ppmu.modal.subheading'),
		isSunriseEnabled,
	};
}
